import selectFolder from './selectFolder';
import { lazyAddFavoriteFolder, lazyRemoveFavoriteFolder } from 'owa-mail-favorites-store';
import { isFolderInFavorites } from 'owa-favorites';
import { getFolderIdForSelectedNode } from 'owa-mail-folder-forest-store';
import { getPersonaNodeIdFromExtendedProperty } from 'owa-mail-persona-search-folder-services';
import { Folder } from 'owa-folders';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { action } from 'satcheljs/lib/legacy';
import { ActionSource } from 'owa-mail-store';

/**
 * Toggle favorite state of a node
 * @param folder the folder
 */
export default action('toggleFavoriteFolder')(async function toggleFavoriteFolder(
    folder: Folder,
    actionSource: ActionSource
) {
    const favoriteNodeId = getPersonaNodeIdFromExtendedProperty(folder);
    const folderId = favoriteNodeId || folder.FolderId.Id;

    if (isFolderInFavorites(folderId)) {
        // Reset the folder selection to inbox if unfavorite a selected node
        if (folderId == getFolderIdForSelectedNode()) {
            selectFolder(folderNameToId('inbox'), 'primaryFolderTree' /* treeType */);
        }
        const removeFavoriteFolder = await lazyRemoveFavoriteFolder.import();
        removeFavoriteFolder(folderId, actionSource);
    } else {
        const addFavoriteFolder = await lazyAddFavoriteFolder.import();
        addFavoriteFolder(folderId, actionSource);
    }
});
